// Create Element.remove() function if not exist - for IE11
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function() {
      if (this.parentNode) {
          this.parentNode.removeChild(this);
      }
  };
}

var codeboxes = document.querySelectorAll('.language-css, .language-js');

//Styles sass with prism after it's loaded into its code container
var codeboxStyler = function () {
  codeboxes.forEach(function(codebox) {
    Prism.highlightElement(codebox);
  });
};

//Generates the sass/js output for each component, using the links in f-item-content.html
$('.f-item-code').each(function() {
  var sassLink = $(this).children('.sass-file');
  var sassCodebox = $(this).find('.language-css');
  var link = sassLink.attr('href');
  var sourceLink;

  if (link) {
    var dotCount = link.match(/\./g).length;
  }

 
  //checks for folder path sass file (multiple dots in file name), ie. '_folder.filename.scss'; removes its folder path
  if (dotCount > 1) {
    var underscorePos = link.indexOf('_');
    var dotPos = link.indexOf('.');
    var linkStart = link.slice(0, underscorePos + 1);
    var linkEnd = link.slice(dotPos + 1, link.length);
    var wholeLink = linkStart + linkEnd;
    sassLink.attr('href', wholeLink);
    sourceLink = wholeLink;
  } else {
    sourceLink = link;
  }

  //populates sass codebox with file data
  if ($(this).find('.sass-file').length !== 0) {
    $.get(sourceLink, function(sassContent){
      sassCodebox.text(sassContent);
      codeboxStyler();
    }, 'text');
  }

  //check if there is an associated js file, and if so, adjust source link and output its data to js codebox
  if ($(this).find('.js-file').length !== 0) {
    var jsCodebox = $(this).find('.language-js');
    var jsSourceLink = sourceLink.replace('output', 'output-js').replace('scss','js');

    $.get(jsSourceLink, function(jsContent){
      jsCodebox.text(jsContent);
      codeboxStyler();
    }, 'text');

  }

});

$('.code-toggle').click(function() {
  var codeType = $(this).data('code');
  var shownCode = $(this).parents().siblings('.code-shown').data('code');

  if (codeType != shownCode) {
    //make this button active, make old active button inactive
    $(this).siblings('.code-toggle.code-shown').toggleClass('code-shown code-hidden');
    $(this).toggleClass('code-hidden code-shown');

    //show this code, hide old code
    $(this).parents().siblings('.code-shown').toggleClass('code-shown code-hidden');
    $(this).parents().siblings('.f-item-' + codeType).toggleClass('code-hidden code-shown');
  }
});

//expand/shrink codebox
$('.f-item-expand').click(function (){
  $(this).parents().children('[data-code]').addClass('full');
  $(this).hide();
  $(this).siblings('.f-item-shrink').show();
});

$('.f-item-shrink').click(function (){
  $(this).parents().children('[data-code]').removeClass('full');
  $(this).hide();
  $(this).siblings('.f-item-expand').show();
});


//Copies nearest active HTML or SCSS to clipboard
var copyCode = function(element) {
  var codeToCopy = element.children('code').text();
  var elementArea = document.createElement('textarea');
  elementArea.setAttribute('id', 'copycode');
  elementArea.style.position = 'fixed';
  elementArea.style.bottom = 0;
  elementArea.style.left = 0;
  document.body.appendChild(elementArea);
  document.getElementById('copycode').value = codeToCopy;
  document.getElementById('copycode').select();
  document.execCommand('Copy');
  document.getElementById('copycode').remove();
}

$('.f-item-copy').click(function() {
  var elementToCopy = $(this).parents().children('.code-shown');
  var button = $(this);
  copyCode(elementToCopy);
  button.html('<i class="fas fa-copy"></i> Copied!');

  setTimeout(function() {
    button.html('<i class="fas fa-copy"></i> Copy code');
  }, 2000);
});

//hide the code on the icons page by default, for easier viewing
$(document).ready(function() {
  $('#f-page-icons .f-item-code').addClass('f-item-hidden');
});

//copy modifier classes and attributes to clipboard //WIP - target .f-item-notes span
var copyClass = function(element) {
  var codeToCopy = element.text();
  var elementArea = document.createElement('textarea');
  elementArea.setAttribute('id', 'copycode');
  elementArea.style.position = 'fixed';
  elementArea.style.bottom = 0;
  elementArea.style.left = 0;
  document.body.appendChild(elementArea);
  document.getElementById('copycode').value = codeToCopy;
  document.getElementById('copycode').select();
  document.execCommand('Copy');
  document.getElementById('copycode').remove();
}

$('.f-item-notes span').attr('title', 'Click to copy');

$('.f-item-notes span').click(function() {
  var span = $(this);
  var spansCopy = $(this).text();
  copyClass(span);
  span.addClass('span-copied');

  setTimeout(function() {
    span.removeClass('span-copied');
  }, 2000);
});


// WEBPACK FOOTER //
// ./src/assets/fabricator/scripts/f-item.js